import {getCustomerHistory} from "../../api/customers";
import {Link, useLoaderData} from "react-router-dom";
import Card from "../../components/UI/Card";
import {checkPermission} from "../../util/auth";
import {useNavigate} from "react-router";
import {useEffect} from "react";


export async function customerDetails({params}){
  const [details] = await Promise.all([
    getCustomerHistory(params.id)
  ]);

  return {details};
}
const CustomerHistory = () => {
  const navigate = useNavigate();
  useEffect(() => {
    if (!checkPermission(['CUSTOMER_DETAILS'])) {
      navigate("/no-access");
    }
  }, [navigate]);

  const {details} = useLoaderData();
  const {customer, orders, status} = details

  return(
    <>

      {!status ?
        <Card>
          <span>
            Customer Not Found
          </span>
        </Card>
        :
        <>
        <Card title={`${customer ? customer.fname + ' ' + customer.lname : 'Customer'}'s personal information`} cardCls={'border_none'} cardBodyCls={'p_0 pb_15'}>
          <div className="table_responsive">
            <table className={'table table_bordered mb_0'}>
              <thead>
                <tr>
                  <td className={'width_200p fw_bold'}>First Name:</td>
                  <td>{customer.fname}</td>
                  <td className={'width_200p fw_bold'}>Last Name:</td>
                  <td>{customer.lname}</td>
                </tr>
                <tr>
                  <td className={'width_200p fw_bold'}>Email:</td>
                  <td>{customer.email}</td>
                  <td className={'width_200p fw_bold'}>Username:</td>
                  <td>{customer.username}</td>

                </tr>
                <tr>
                  <td className={'width_200p fw_bold'}>Street:</td>
                  <td>{customer.street}</td>
                  <td className={'width_200p fw_bold'}>City:</td>
                  <td>{customer.city}</td>
                </tr>
                <tr>
                  <td className={'width_200p fw_bold'}>State:</td>
                  <td>{customer.state}</td>
                  <td className={'width_200p fw_bold'}>Zip Code:</td>
                  <td>{customer.zipcode}</td>
                </tr>
                <tr>
                  <td className={'width_200p fw_bold'}>Phone:</td>
                  <td>{customer.phone}</td>
                  <td className={'width_200p fw_bold'}>Last Order:</td>
                  <td>{customer.last_order}</td>
                </tr>
                <tr>
                  <td className={'width_200p fw_bold'}>Total Order:</td>
                  <td>{customer.count}</td>
                  <td className={'width_200p fw_bold'}></td>
                  <td></td>
                </tr>
              </thead>
            </table>
          </div>
        </Card>

        <Card title={`${customer ? customer.fname + ' ' + customer.lname : 'Customer'}'s Orders`}>
          <div className="table_responsive">
            <table className={'table'}>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Date</th>
                  <th>Order Number</th>
                  <th>Shipping Method</th>
                  <th>Commission Rate</th>
                  <th>Commission Amount</th>
                  <th>Total</th>
                  <th className={'text_right'}>Action</th>
                </tr>
              </thead>
              <tbody>
              {orders.map((item, i)=>
                <tr>
                  <td>{++i}</td>
                  <td>{item.created_at}</td>
                  <td>{item.order_number}</td>
                  <td>{item.shipping_method ? item.shipping_method.name : null}</td>
                  <td>{item.vendor_commission_rate ? item.vendor_commission_rate : 0}%</td>
                  <td>${item.vendor_commission_amount ? item.vendor_commission_amount : '0.00'}</td>
                  <td>${item.total.toFixed(2)}</td>
                  <td className={'text_right'}>
                    {checkPermission(['ORDER_READ']) &&
                    <Link className={"btn btn_black has_border_radius btn_sm"} to={"/orders/" + item.id}>Details</Link>
                    }
                  </td>
                </tr>
              )}
              </tbody>
            </table>
          </div>
        </Card>

        </>
      }

    </>
  );
}

export default CustomerHistory;